import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import Cascader from 'element-ui/lib/cascader';
import { isEqual } from 'element-ui/lib/utils/util';
export default {
  name: 'MyCascader',
  components: {},
  extends: Cascader,
  props: {
    collapseTags: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    options: {
      handler: function handler(val) {
        this.options = this.fmtOptions(val);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // if (this.multiple) {
    //   this.panel.getFlattedNodes = () => {
    //     return this.getFlattedNodes2(this.panel.store.nodes, [])
    //   }
    //   this.panel.syncMultiCheckState()
    // }
  },
  methods: {
    getFlattedNodes2: function getFlattedNodes2(nodes, gatherArr) {
      var _this = this;
      nodes.forEach(function (node) {
        if (node.checked) {
          gatherArr.push(node);
        } else {
          if (node.children && node.children.length) {
            _this.getFlattedNodes2(node.children, gatherArr);
          } else {
            gatherArr.push(node);
          }
        }
      });
      return gatherArr;
    },
    deleteTag: function deleteTag(tag) {
      var _this2 = this;
      var checkedValue = this.checkedValue;
      var current = tag.node.getValueByOption();
      var val = checkedValue.find(function (n) {
        return isEqual(n, current);
      });
      this.checkedValue = checkedValue.filter(function (n) {
        return !isEqual(n, current);
      });
      this.$nextTick(function () {
        _this2.checkedValue = _this2.getCheckedNodes().map(function (item) {
          return item.path;
        }).filter(function (n) {
          return !isEqual(n, current);
        });
        _this2.$emit('remove-tag', val);
      });
    },
    fmtOptions: function fmtOptions(list) {
      var _this3 = this;
      Array.isArray(list) && list.forEach(function (item) {
        item.children = Array.isArray(item.children) && item.children.length ? item.children : null;
        item.children && _this3.fmtOptions(item.children);
      });
      return list;
    }
  }
};